import { IAtlasPreviewTarget } from '../atlasPreview/actions'

export const prefix = 'atlasModulePanel'

export const OPEN_ATLAS_MODULE_PANEL = `${prefix}/OPEN_ATLAS_MODULE_PANEL`
export const CLOSE_ATLAS_MODULE_PANEL = `${prefix}/CLOSE_ATLAS_MODULE_PANEL`
export const ATLAS_MODULE_PANEL_RECORD_CHANGED = `${prefix}/ATLAS_MODULE_PANEL_RECORD_CHANGED`

/**
 * Asks for a record in the split-screen panel beside AIM. Features should call
 * `useAtlasModulePanel().openInPanel`, which navigates instead where no panel can show.
 */
export const openAtlasModulePanel = (target: IAtlasPreviewTarget) => ({
  type: OPEN_ATLAS_MODULE_PANEL,
  data: target,
})

export const closeAtlasModulePanel = () => ({
  type: CLOSE_ATLAS_MODULE_PANEL,
})

/** The record in the panel was edited, so a page listing it beside the panel should refetch. */
export const atlasModulePanelRecordChanged = () => ({
  type: ATLAS_MODULE_PANEL_RECORD_CHANGED,
})
